require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-new-report-on-world-bank-lending-in-peru-not-seeing-the-forestor-the-trees.json") })
        }
      }, "path---en-us-update-new-report-on-world-bank-lending-in-peru-not-seeing-the-forestor-the-trees");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-new-report-on-world-bank-lending-in-peru-not-seeing-the-forestor-the-trees!./.cache/json/en-us-update-new-report-on-world-bank-lending-in-peru-not-seeing-the-forestor-the-trees.json
// module id = 780
// module chunks = 231608221292675